import {ObjectUtil} from '../../util/object-util';

export class ExternalInsurer {
  name: string = null;
  streetName: string = null;
  houseNumber: string = null;
  postalCode: string = null;
  location: string = null;
  countryCode: string = null;

  constructor(externalInsurer: Partial<ExternalInsurer>) {
    ObjectUtil.assign(this, externalInsurer);
  }
}
